import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import Landscape from '@material-ui/icons/Landscape';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import { DatePicker } from 'material-ui-pickers';
import SearchBar from '../../../components/SearchBar/SearchBar';
import SkidataOverviewTable from './SkidataOverviewTable';
import {
  getMgbOrderSummaries,
  flushPrices,
} from '../schema/skidata-schema.graphql';
import { compose, graphql, withApollo } from 'react-apollo';
import { withSearch } from '../../../context/SearchResultsContext';
import { withSnackbar } from '../../snackbar/SnackbarContext';
import FlushPricesButton from './FlushPricesButton';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
});

class MgbOverview extends React.Component {
  state = {
    page: 0,
    rowsPerPage: 5,
    validFrom: null,
    validTo: null,
  };

  onValidFromChange = date => {
    this.setState({
      validFrom: date,
    });
  };

  onValidToChange = date => {
    this.setState({
      validTo: date,
    });
  };

  componentDidMount() {
    this.onSearchRequest('');
  }

  onSearchRequest = async value => {
    const { validFrom, validTo } = this.state;
    const { setSearchResults, addNotification, client } = this.props;

    this.setState({ loading: true });
    try {
      const { data } = await client.query({
        fetchPolicy: 'network-only',
        query: getMgbOrderSummaries,
        variables: {
          query: value,
          validFrom: validFrom
            ? moment(validFrom)
                .startOf('day')
                .toISOString()
            : undefined,
          validTo: validTo
            ? moment(validTo)
                .endOf('day')
                .toISOString()
            : undefined,
        },
      });
      setSearchResults(value, data.orders.filter(o => o.state !== 'PENDING'));
    } catch (error) {
      addNotification('danger', 'Unerwarteter Fehler aufgetreten');
      console.error(error);
    }
    this.setState({ loading: false });
  };

  onSyncPrices = async () => {};

  render() {
    const { classes, history, getSearchResults, flushPrices } = this.props;
    const { loading, validFrom, validTo } = this.state;

    return (
      <div className={classes.root}>
        <Card>
          <CardHeader icon stats>
            <CardIcon color="rose">
              <Landscape />
            </CardIcon>
          </CardHeader>
          <CardBody>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row-reverse',
                width: '100%',
              }}
            >
              <FlushPricesButton onSyncPrices={flushPrices} />
            </div>
            <div style={{ maxWidth: 480, margin: '40px auto' }}>
              <div style={{ marginBottom: 20, display: 'flex' }}>
                <div style={{ marginRight: 20, maxWidth: 100 }}>
                  <DatePicker
                    cancelLabel={'Abbrechen'}
                    clearLabel={'L\u00d6schen'}
                    label={'G\u00fcltig von'}
                    variant="outlined"
                    value={validFrom}
                    onChange={this.onValidFromChange}
                    format={'DD.MM.YYYY'}
                    clearable
                    InputProps={{ style: { fontSize: 14 } }}
                    InputLabelProps={{ style: { fontSize: 14 } }}
                  />
                </div>
                <div style={{ maxWidth: 100 }}>
                  <DatePicker
                    cancelLabel={'Abbrechen'}
                    clearLabel={'L\u00d6schen'}
                    label={'G\u00fcltig bis'}
                    variant="outlined"
                    value={validTo}
                    onChange={this.onValidToChange}
                    format={'DD.MM.YYYY'}
                    clearable
                    InputProps={{ style: { fontSize: 14 } }}
                    InputLabelProps={{ style: { fontSize: 14 } }}
                  />
                </div>
              </div>
              <SearchBar
                initialQuery={getSearchResults().query}
                onRequestSearch={this.onSearchRequest}
                loading={loading}
              />
            </div>
            <SkidataOverviewTable
              orders={getSearchResults().results}
              onOrderClick={id => history.push(`/partner/mgb/${id}`)}
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

MgbOverview.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const enhance = compose(
  graphql(flushPrices, { name: 'flushPrices' }),
  withSnackbar,
  withSearch('skidata-overview'),
  withStyles(styles),
  withApollo
);
export default enhance(MgbOverview);



// WEBPACK FOOTER //
// ./src/views/skidata/components/MgbOverview.jsx